import React from 'react';
import NavBar from "./NavBar";
import HeroSection from "./HeroSection";
import FeatureSection from "./FeatureSection";
import PricingSection from "./PricingSection";
import Footer from "./Footer";

function HomePage() {
    return (
        <div className="content-wrap">
            <NavBar/>
            <HeroSection/>
            <FeatureSection/>
            <PricingSection/>
            <Footer/>


            {/* Other components or content can go here */}
        </div>
    );
}

export default HomePage;